import { render, staticRenderFns } from "./position-item.vue?vue&type=template&id=4e532974"
import script from "./position-item.vue?vue&type=script&lang=js"
export * from "./position-item.vue?vue&type=script&lang=js"
import style0 from "./position-item.vue?vue&type=style&index=0&id=4e532974&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports